import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SITE_CONFIG } from "@/data/siteConfig";

const LINKS = [
  { label: "Shop", to: "/shop" },
  { label: "Projects", to: "/projects" },
  { label: "Gifts", to: "/gifts" },
  { label: "Visit", to: "/visit" },
  { label: "About", to: "/about" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-bone border-t border-rule">
      <div className="container-wide py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-8">
          <div className="md:col-span-4">
            <img
              src={SITE_CONFIG.brand.logoTransparent}
              alt="Cactus Rose Needle Arts"
              className="w-28 md:w-32 h-auto"
            />
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-ink">
              A local, independent needle-arts shop in Las Vegas.
            </p>
          </div>

          <div className="md:col-span-2 md:col-start-6">
            <p className="text-sm font-semibold mb-4">Explore</p>
            <ul className="space-y-3">
              {LINKS.map((link) => (
                <li key={link.label}>
                  <Link to={link.to} className="text-sm text-ink hover:text-clay transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="text-sm font-semibold mb-4">Visit</p>
            <address className="not-italic text-sm text-ink leading-relaxed">
              {SITE_CONFIG.location.addressLine1}
              <br />
              {SITE_CONFIG.location.addressLine2}
              <br />
              {SITE_CONFIG.location.venue}
            </address>
            <p className="mt-3 text-sm text-ink leading-relaxed">
              {SITE_CONFIG.hours.openDays}
              <br />
              {SITE_CONFIG.hours.openTime}
              <br />
              {SITE_CONFIG.hours.closedDays}
            </p>
            <a href={SITE_CONFIG.phone.href} className="inline-block mt-3 text-sm font-medium hover:text-clay">
              {SITE_CONFIG.phone.display}
            </a>
          </div>

          <div className="md:col-span-2">
            <p className="text-sm font-semibold mb-4">Online</p>
            <a
              href={SITE_CONFIG.links.shopify}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-1.5 text-sm text-ink hover:text-clay transition-colors"
            >
              Shop on Shopify
              <ArrowUpRight className="w-3.5 h-3.5" strokeWidth={1.7} />
            </a>
          </div>
        </div>

        <div className="mt-12 pt-5 border-t border-rule text-xs text-ink">
          <p>© {new Date().getFullYear()} {SITE_CONFIG.businessName}</p>
        </div>
      </div>
    </footer>
  );
}
